import Layout from "../components/Layout";
import ExportTable from "../components/Tables/ExportTable";
import { hasAccess } from "../helper/permissions";

export default function Export() {
    
    const tableData = [
        {
            title: 'خروجی سفارشات',
            access:hasAccess('export orders'),
            dateFrom:'',
            dateTo:'',
            url:'https://media.entekhabcenter.com/forms/app_exportmanager_repository_exportorderrepository_.csv?v='+Date.now().toString(),
            request: true
        },
        {
            title: 'خروجی محصولات',
            access:hasAccess('export products'),
            dateFrom:'',
            dateTo:'',
            url:'https://media.entekhabcenter.com/forms/app_exportmanager_repository_exportproductrepository_.csv?v='+Date.now().toString(),
            request: false
        },
        {
            title: 'خروجی انبارداری',
            access:hasAccess('export inventory'),
            dateFrom:'',
            dateTo:'',
            url:'https://media.entekhabcenter.com/forms/app_exportmanager_repository_exportinventoryrepository_.csv?v='+Date.now().toString(),
            request: false
        },
        {
            title: 'خروجی تحلیل قیمت',
            access:hasAccess('export analysis'),
            dateFrom:'',
            dateTo:'',
            url:'https://media.entekhabcenter.com/forms/app_exportmanager_repository_exportinventoryanalysisrepository_.csv?v='+Date.now().toString(),
            request: false
        },
        {
            title: 'خروجی مشتریان',
            access:hasAccess('export customers'),
            dateFrom:'',
            dateTo:'',
            url:'https://media.entekhabcenter.com/forms/app_exportmanager_repository_exportcustomerrepository_.csv?v='+Date.now().toString(),
            request: false
        },
    ]
    return (
        <Layout>
            <div>
                <div className="page-title mb-3"><span className="inline-block bg-white pl-3">خروجی ها</span></div>
                <div className="main-content p-1 mt-3">
                    <ExportTable tableData={tableData} />
                </div>
            </div>
        </Layout>
    )
}